import { TKV2_ORDER_API, ToolkitOrder } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { fetchGetTkv2OrderAPI } from '../../hooks/api/toolkitComponents.ts';
import { useToolkitContext } from '../../hooks/api/toolkitContext.ts';

export const useTkv2Order = (
  params: { pathParams: { orderID: string } },
  opts?: Omit<UseQueryOptions<ToolkitOrder>, 'queryKey' | 'queryFn'>,
): UseQueryResult<ToolkitOrder> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<ToolkitOrder>({
    queryKey: ['order', params.pathParams.orderID],
    queryFn: async () => {
      const res = await fetchGetTkv2OrderAPI({ ...fetcherOptions, ...params });
      return TKV2_ORDER_API.GET.RESPONSE.parse(res);
    },
    ...opts,
  });
};
